import { useEffect, useRef } from 'react';
import { pickDefaultAccountingPeriod, type AccPeriodLike } from './reportUtils';

/** Apply the default accounting period once the periods list is available. */
export function useDefaultAccountingPeriod(
  periods: AccPeriodLike[],
  apply: (period: AccPeriodLike) => void,
  enabled = true,
) {
  const appliedRef = useRef(false);
  const applyRef = useRef(apply);
  applyRef.current = apply;

  useEffect(() => {
    if (!enabled || appliedRef.current || periods.length === 0) return;
    const match = pickDefaultAccountingPeriod(periods);
    if (!match) return;
    applyRef.current(match);
    appliedRef.current = true;
  }, [enabled, periods]);
}
